import $ from 'jquery'
const initializeHeader = () => {
	// --- menu mobile: open subnav if active ---
	const openActiveSubnav = () => {
		if (window.matchMedia('(max-width: 1023px)').matches) {
			$('.active > .sub-nav-button')
				.addClass('is-open')
				.attr('aria-expanded', true)
				.siblings('ul')
				.addClass('is-open')
		}
	}
	$(window).on('load', openActiveSubnav)

	// --- toggle menu mobile ---
	const toggleMenu = (event) => {
		event.preventDefault()
		$('.js-menu-toggle')
			.toggleClass('is-open')
			.attr('aria-expanded', function (index, attr) {
				if (attr === 'true') {
					return 'false'
				} else {
					return 'true'
				}
			})
		$('.nav-main').toggleClass('is-open')
		$('body').toggleClass('menu-open')
	}
	$('.js-menu-toggle').on('click', toggleMenu)

	// --- toggle submenu mobile ---
	const toggleSubMenu = (event) => {
		event.preventDefault()
		$(event.target)
			.toggleClass('is-open')
			.attr('aria-expanded', function (index, attr) {
				if (attr === 'true') {
					return 'false'
				} else {
					return 'true'
				}
			})
			.siblings('ul')
			.toggleClass('is-open')
	}
	$('.js-sub-nav-button').on('click', toggleSubMenu)
}

export default initializeHeader
